export const PortalSelector = {
  ADD_TO_HOME_SCREEN: 'add-to-home-screen-portal',
};

export const portalsSelectors = [
  PortalSelector.ADD_TO_HOME_SCREEN,
];
